import React, { useEffect, useState } from 'react'
import Menu from "../Menu";

const MessageQueueList = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [payloadDialogOpen, setPayloadDialogOpen] = useState(false);
  const [payloadDialogContent, setPayloadDialogContent] = useState('');
  const [modalTitle, setModalTitle] = useState('');
  const [exportOpen, setExportOpen] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [exportError, setExportError] = useState('');
  const [exportForm, setExportForm] = useState({ posid: '', status: '', devicestatus: '', fromdate: '', todate: '' });
  const [filters, setFilters] = useState({
    id: '',
    posid: '',
    status: '',
    msgtype: '',
    devicestatus: '',
    isqueue: ''
  });
  const [pageSize, setPageSize] = useState(100);
  const [pageNo, setPageNo] = useState(0);
  const [hasMore, setHasMore] = useState(true);

  // UI helpers
  const formatDate = (value) => {
    if (!value) return '';
    try {
      const d = new Date(value);
      if (isNaN(d.getTime())) return value;
      return d.toLocaleString();
    } catch (_) {
      return value;
    }
  };

  const renderStatusBadge = (status) => {
    const s = (status || '').toLowerCase();
    const cls = s === 'delivered' ? 'success' : s === 'queue' ? 'secondary' : s === 'expire' ? 'danger' : 'info';
    return <span className={`badge badge-${cls}`}>{status || '-'}</span>;
  };

  const renderDeviceBadge = (dev) => {
    const s = (dev || '').toLowerCase();
    const cls = s === 'connected' ? 'success' : s === 'disconnected' ? 'secondary' : 'light';
    return <span className={`badge badge-${cls}`}>{dev || '-'}</span>;
  };

  const token = getCookie("token") || getCookie("authToken");
  const userid = getCookie("userid") || getCookie("userId");

  const baseURL = 'https://api.dqr-display-tms.eventum.co.in/api/SocketQueueOperation/SubUser';

  const buildPayload = () => {
    return {
      ispageload: false,
      pagesize: Number(pageSize),
      currentpageno: Number(pageNo),
      withoutpagination: false,
      pagedirection: 'last',
      id: Number(filters.id) || 0,
      posid: Number(filters.posid) || 0,
      status: String(filters.status || ''),
      devicestatus: String(filters.devicestatus || ''),
      isqueue: String(filters.isqueue || '')
    };
  };

  const fetchQueue = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(`${baseURL}/Search`, {
        method: 'POST',
        headers: {
          accept: 'text/plain',
          'Content-Type': 'application/json-patch+json',
          UserId: userid,
          'X-Authorization': token,
        },
        body: JSON.stringify(buildPayload()),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      const rows = Array.isArray(data?.data) ? data.data : [];
      setItems(rows);
      setHasMore(rows.length === Number(pageSize));
    } catch (err) {
      setError('Failed to fetch message queue: ' + err.message);
      console.error('Error fetching message queue:', err);
    } finally {
      setLoading(false);
    }
  };

  const buildExportPayload = () => {
    const toEpochSeconds = (d, endOfDay = false) => {
      try {
        if (!d) return 0;
        const date = new Date(d);
        if (isNaN(date.getTime())) return 0;
        if (endOfDay) {
          date.setHours(23, 59, 59, 999);
        } else {
          date.setHours(0, 0, 0, 0);
        }
        return Math.floor(date.getTime() / 1000);
      } catch (_) {
        return 0;
      }
    };
    const apply = Boolean(exportForm.fromdate) || Boolean(exportForm.todate);
    return {
      posid: Number(exportForm.posid) || 0,
      subuserid: 0,
      applycreateddate: apply,
      fromcreateddate: toEpochSeconds(exportForm.fromdate, false),
      endcreateddate: toEpochSeconds(exportForm.todate, true),
      status: String(exportForm.status || ''),
      acknowledgementstatus: '',
      reqid: '',
      msgtype: String(filters.msgtype || ''),
      devicestatus: String(exportForm.devicestatus || ''),
      isqueue: String(filters.isqueue || ''),
      ispageload: false,
      pagesize: 11,
      currentpageno: 0,
      withoutpagination: false,
      pagedirection: 'frist'
    };
  };

  const openExportModal = () => {
    setExportError('');
    setExportForm({
      posid: String(filters.posid || ''),
      status: String(filters.status || ''),
      devicestatus: String(filters.devicestatus || ''),
      fromdate: '',
      todate: ''
    });
    setExportOpen(true);
  };

  const closeExportModal = () => {
    if (exportLoading) return;
    setExportOpen(false);
  };

  const downloadExport = async () => {
    if (!token || !userid) {
      setExportError('Missing auth.');
      return;
    }
    setExportLoading(true);
    setExportError('');
    try {
      const res = await fetch(`${baseURL}/Download`, {
        method: 'POST',
        headers: {
          accept: '*/*',
          'Content-Type': 'application/json-patch+json',
          UserId: userid,
          'X-Authorization': token,
        },
        body: JSON.stringify(buildExportPayload()),
      });

      if (!res.ok) {
        const text = await res.text();
        throw new Error(`HTTP ${res.status}: ${text}`);
      }

      const blob = await res.blob();
      const contentDisposition = res.headers.get('Content-Disposition') || res.headers.get('content-disposition');
      let filename = 'MessageQueue.xlsx';
      if (contentDisposition) {
        const match = contentDisposition.match(/filename\*=UTF-8''([^;\n]+)/) || contentDisposition.match(/filename=\"?([^\";\n]+)\"?/);
        if (match && match[1]) {
          filename = decodeURIComponent(match[1]);
        }
      }

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      setExportOpen(false);
    } catch (err) {
      setExportError(err.message || 'Failed to export');
    } finally {
      setExportLoading(false);
    }
  };

  const openPayloadDialog = (rawPayload) => {
    let formatted = '';
    try {
      const parsed = typeof rawPayload === 'string' ? JSON.parse(rawPayload) : rawPayload;
      formatted = JSON.stringify(parsed, null, 2);
    } catch (_) {
      formatted = String(rawPayload ?? '');
    }
    setPayloadDialogContent(formatted);
    setModalTitle('Payload');
    setPayloadDialogOpen(true);
  };

  const openAcknowledgementDialog = (raw) => {
    const content = raw == null ? '' : String(raw);
    setPayloadDialogContent(content);
    setModalTitle('Acknowledgement');
    setPayloadDialogOpen(true);
  };

  const closePayloadDialog = () => {
    setPayloadDialogOpen(false);
    setPayloadDialogContent('');
  };

  const expireItem = async (id) => {
    if (!id) return;
    setLoading(true);
    setError(null);
    try {
      const res = await fetch(`${baseURL}/UpdateStatus/expire`, {
        method: 'POST',
        headers: {
          accept: 'text/plain',
          'Content-Type': 'application/json-patch+json',
          UserId: userid,
          'X-Authorization': token,
        },
        body: JSON.stringify({ id })
      });
      if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
      await fetchQueue();
    } catch (err) {
      setError('Failed to expire item: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  const updateItem = async (id, status = 'queue', retry = 0) => {
    if (!id) return;
    setLoading(true);
    setError(null);
    try {
      const res = await fetch(`${baseURL}/Update`, {
        method: 'POST',
        headers: {
          accept: 'text/plain',
          'Content-Type': 'application/json-patch+json',
          UserId: userid,
          'X-Authorization': token,
        },
        body: JSON.stringify({ id, status, retry })
      });
      if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
      await fetchQueue();
    } catch (err) {
      setError('Failed to update item: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  const deleteItem = async (id) => {
    if (!id) return;
    if (!window.confirm('Delete this queue item?')) return;
    setLoading(true);
    setError(null);
    try {
      const res = await fetch(`${baseURL}/Delete`, {
        method: 'POST',
        headers: {
          accept: 'text/plain',
          'Content-Type': 'application/json-patch+json',
          UserId: userid,
          'X-Authorization': token,
        },
        body: JSON.stringify({ id })
      });
      if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
      await fetchQueue();
    } catch (err) {
      setError('Failed to delete item: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchQueue();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNo, pageSize]);

  const onSearchSubmit = (e) => {
    e.preventDefault();
    setPageNo(0);
    fetchQueue();
  };

  const onResetFilters = () => {
    setFilters({
      id: '', posid: '', status: '', msgtype: '', devicestatus: '', isqueue: ''
    });
    setPageNo(0);
    fetchQueue();
  };

  const goFirst = () => { if (pageNo !== 0) setPageNo(0); };
  const goPrev = () => { if (pageNo > 0) setPageNo(pageNo - 1); };
  const goNext = () => { if (hasMore) setPageNo(pageNo + 1); };

  return (
    <>
      <Menu />
      <div className="wrapper">
        <div className="content-wrapper">
        <section className="content-header">
            <div className="container-fluid">
              <div className="d-flex justify-content-between align-items-center w-100">
                <h1 className="mb-0">Message Queue</h1>
                <button type="button" className="btn btn-success" onClick={openExportModal}>
                <i className="fas fa-download mr-1"></i>Export
                </button>
              </div>
            </div>
          </section>
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="card">
                  
                  <div className="card-body">
                    {error && (
                      <div className="alert alert-danger alert-dismissible fade show" role="alert">
                        {error}
                        <button type="button" className="close" onClick={() => setError(null)}>
                          <span>&times;</span>
                        </button>
                      </div>
                    )}

                    {/* Advanced Search */}
                    <form className="mb-3" onSubmit={onSearchSubmit}>
                      <div className="card card-body p-3 mb-2" style={{background:'#f8f9fa'}}>
                        <div className="row">
                          <div className="col-md-2 col-sm-6 mb-2">
                            <input 
                              type="number" 
                              className="form-control form-control-sm" 
                              placeholder="ID" 
                              value={filters.id} 
                              onChange={(e)=>setFilters({...filters, id: e.target.value})} 
                            />
                          </div>
                          <div className="col-md-2 col-sm-6 mb-2">
                            <input 
                              type="number" 
                              className="form-control form-control-sm" 
                              placeholder="POS ID" 
                              value={filters.posid} 
                              onChange={(e)=>setFilters({...filters, posid: e.target.value})} 
                            />
                          </div>
                          <div className="col-md-2 col-sm-6 mb-2">
                            <select 
                              className="form-control form-control-sm" 
                              value={filters.status} 
                              onChange={(e)=>setFilters({...filters, status: e.target.value})}
                            >
                              <option value="">All Status</option>
                              <option value="delivered">Delivered</option>
                              <option value="queue">Queue</option>
                              <option value="expire">Expire</option>
                              <option value="Acknowledgement">Acknowledgement</option>
                            </select>
                          </div>
                          <div className="col-md-3 col-sm-6 mb-2">
                            <select 
                              className="form-control form-control-sm" 
                              value={filters.devicestatus} 
                              onChange={(e)=>setFilters({...filters, devicestatus: e.target.value})}
                            >
                              <option value="">All Device Status</option>
                              <option value="connected">Connected</option>
                              <option value="disconnected">Disconnected</option>
                            </select>
                          </div>
                          <div className="col-md-3 col-sm-12 mb-2">
                            <div className="btn-group btn-block" role="group">
                              <button type="submit" className="btn btn-success btn-sm" disabled={loading}>
                                <i className="fas fa-search mr-1"></i>Search
                              </button>
                              <button type="button" className="btn btn-secondary btn-sm" onClick={onResetFilters} disabled={loading}>
                                <i className="fas fa-redo mr-1"></i>Reset
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      {Object.entries(filters).filter(([,v]) => (v ?? '') !== '').length > 0 && (
                        <div className="mb-2">
                          <small className="text-muted">Active filters: </small>
                          {Object.entries(filters).filter(([,v]) => (v ?? '') !== '').map(([k,v]) => (
                            <span key={k} className="badge badge-light mr-2" style={{fontWeight:500}}>
                              {k}: {v}
                            </span>
                          ))}
                        </div>
                      )}
                    </form>

                    {loading && (
                      <div className="text-center py-5">
                        <div className="spinner-border text-primary" role="status">
                          <span className="sr-only">Loading...</span>
                        </div>
                        <p className="mt-2 text-muted">Loading message queue...</p>
                      </div>
                    )}

                    {!loading && items.length === 0 && !error && (
                      <div className="alert alert-info">
                        <i className="fas fa-info-circle mr-2"></i>No queue items found.
                      </div>
                    )}

                    {/* Summary */}
                    {!loading && items.length > 0 && (() => {
                      const total = items.length;
                      const delivered = items.filter(r => (r.status||'').toLowerCase() === 'delivered').length;
                      const queue = items.filter(r => (r.status||'').toLowerCase() === 'queue').length;
                      const expire = items.filter(r => (r.status||'').toLowerCase() === 'expire').length;
                      const acknowledgement = items.filter(r => (r.status||'').toLowerCase() === 'acknowledgement').length;
                      return (
                        <div className="d-flex justify-content-between align-items-center flex-wrap mb-3">
                          <div className="mb-2">
                            <span className="badge badge-primary mr-2 p-2">Total: {total}</span>
                            <span className="badge badge-success mr-2 p-2">Delivered: {delivered}</span>
                            <span className="badge badge-secondary mr-2 p-2">Queue: {queue}</span>
                            <span className="badge badge-danger mr-2 p-2">Expire: {expire}</span>
                            <span className="badge badge-warning mr-2 p-2">Acknowledgement: {acknowledgement}</span>
                          </div>
                          <div className="mb-2">
                            <div className="input-group input-group-sm" style={{width: 180}}>
                              <div className="input-group-prepend">
                                <span className="input-group-text">Page size</span>
                              </div>
                              <select 
                                className="form-control" 
                                value={pageSize} 
                                onChange={(e)=>setPageSize(Number(e.target.value))}
                              >
                                <option value={10}>10</option>
                                <option value={20}>20</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      );
                    })()}

                    {!loading && items.length > 0 && (
                      <>
                        <div className="table-responsive">
                          <table className="table table-sm table-bordered table-striped table-hover">
                            <thead className="thead-light">
                              <tr className="text-nowrap">
                                <th>ID</th>
                                <th>Created</th>
                                <th>POS</th>
                                <th>POS Name</th>
                                <th>Status</th>
                                <th>Device</th>
                                <th>Retry</th>
                                <th>Delivered</th>
                                <th>Data</th>
                                <th className="text-center">Actions</th>
                              </tr>
                            </thead>
                            <tbody className="align-middle">
                              {items.map((row) => (
                                <tr key={row.id}>
                                  <td>{row.id}</td>
                                  <td className="text-nowrap">{formatDate(row.createddate)}</td>
                                  <td>{row.posid}</td>
                                  <td>{row.posname}</td>
                                  <td>{renderStatusBadge(row.status)}</td>
                                  <td>{renderDeviceBadge(row.devicestatus)}</td>
                                  <td>{row.retry}/{row.retrylimit}</td>
                                  <td className="text-nowrap">{formatDate(row.delivereddate)}</td>
                                  <td className="text-nowrap">
                                    <div className="btn-group btn-group-sm" role="group">
                                      <button 
                                        className="btn btn-outline-primary" 
                                        onClick={() => openPayloadDialog(row.payload)}
                                        title="View Message Queue"
                                      >
                                        <i className="fas fa-file-alt mr-1"></i>Message
                                      </button>
                                      <button 
                                        className="btn btn-outline-secondary" 
                                        onClick={() => openAcknowledgementDialog(row.acknowledgementdata)}
                                        title="View Acknowledgement"
                                      >
                                        <i className="fas fa-check-circle mr-1"></i>Ack
                                      </button>
                                    </div>
                                  </td>
                                  <td className="text-nowrap text-center">
                                    <div className="btn-group btn-group-sm" role="group">
                                      <button 
                                        className="btn btn-warning" 
                                        disabled={loading} 
                                        onClick={() => expireItem(row.id)}
                                        title="Mark as expired"
                                      >
                                        <i className="fas fa-clock"></i>
                                      </button>
                                      <button 
                                        className="btn btn-info" 
                                        disabled={loading} 
                                        onClick={() => updateItem(row.id, 'queue', 0)}
                                        title="Reset to queue"
                                      >
                                        <i className="fas fa-redo"></i>
                                      </button>
                                      <button 
                                        className="btn btn-danger" 
                                        disabled={loading} 
                                        onClick={() => deleteItem(row.id)}
                                        title="Delete item"
                                      >
                                        <i className="fas fa-trash"></i>
                                      </button>
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>

                        {/* Pagination */}
                        <div className="d-flex justify-content-between align-items-center mt-3">
                          <div>
                            <button 
                              className="btn btn-outline-secondary btn-sm mr-2" 
                              onClick={goFirst} 
                              disabled={loading || pageNo === 0}
                            >
                              <i className="fas fa-angle-double-left"></i> First
                            </button>
                            <button 
                              className="btn btn-outline-secondary btn-sm" 
                              onClick={goPrev} 
                              disabled={loading || pageNo === 0}
                            >
                              <i className="fas fa-angle-left"></i> Prev
                            </button>
                          </div>
                          <div>
                            <span className="badge badge-light p-2">Page {pageNo + 1}</span>
                          </div>
                          <div>
                            <button 
                              className="btn btn-outline-secondary btn-sm" 
                              onClick={goNext} 
                              disabled={loading || !hasMore}
                            >
                              Next <i className="fas fa-angle-right"></i>
                            </button>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Export Modal */}
      {exportOpen && (
        <div className="modal" style={{display:'block', background:'rgba(0,0,0,0.5)', overflowY: 'auto'}}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  <i className="fas fa-download mr-2"></i>Export Message Queue
                </h5>
                <button type="button" className="close" onClick={closeExportModal} disabled={exportLoading}>
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body">
                {exportError && (
                  <div className="alert alert-danger" role="alert" style={{whiteSpace:'pre-wrap'}}>
                    {exportError}
                  </div>
                )}
               
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="small mb-1">POS ID</label>
                    <input 
                      type="number" 
                      className="form-control" 
                      value={exportForm.posid} 
                      onChange={(e)=>setExportForm({...exportForm, posid: e.target.value})} 
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="small mb-1">Status</label>
                    <select 
                      className="form-control" 
                      value={exportForm.status} 
                      onChange={(e)=>setExportForm({...exportForm, status: e.target.value})}
                    >
                      <option value="">Any</option>
                      <option value="delivered">Delivered</option>
                      <option value="queue">Queue</option>
                      <option value="expire">Expire</option>
                      <option value="acknowledgement">Acknowledgement</option>
                    </select>
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="small mb-1">Device Status</label>
                    <select 
                      className="form-control" 
                      value={exportForm.devicestatus} 
                      onChange={(e)=>setExportForm({...exportForm, devicestatus: e.target.value})}
                    >
                      <option value="">Any</option>
                      <option value="connected">Connected</option>
                      <option value="disconnected">Disconnected</option>
                    </select>
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="small mb-1">From Date</label>
                    <input 
                      type="date" 
                      className="form-control" 
                      value={exportForm.fromdate} 
                      onChange={(e)=>setExportForm({...exportForm, fromdate: e.target.value})} 
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="small mb-1">To Date</label>
                    <input 
                      type="date" 
                      className="form-control" 
                      value={exportForm.todate} 
                      onChange={(e)=>setExportForm({...exportForm, todate: e.target.value})} 
                    />
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button 
                  type="button" 
                  className="btn btn-secondary" 
                  onClick={closeExportModal} 
                  disabled={exportLoading}
                >
                  Close
                </button>
                <button 
                  type="button" 
                  className="btn btn-success" 
                  onClick={downloadExport} 
                  disabled={exportLoading}
                >
                  {exportLoading ? (
                    <>
                      <span className="spinner-border spinner-border-sm mr-2" role="status"></span>
                      Preparing…
                    </>
                  ) : (
                    <>
                      <i className="fas fa-file-excel mr-2"></i>
                      Download Excel
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Payload Dialog */}
      {payloadDialogOpen && (
        <div className="modal" style={{display:'block', background:'rgba(0,0,0,0.5)', overflowY: 'auto'}}>
          <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  <i className="fas fa-code mr-2"></i>{modalTitle || 'Details'}
                </h5>
                <button type="button" className="close" onClick={closePayloadDialog}>
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body" style={{maxHeight:'70vh', overflow:'auto', background:'#f8f9fa'}}>
                <pre style={{whiteSpace:'pre-wrap', wordBreak:'break-word', margin:0, padding: '15px', background: '#fff', border: '1px solid #dee2e6', borderRadius: '4px'}}>{payloadDialogContent}</pre>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={closePayloadDialog}>
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MessageQueueList;

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
  return null;
}